<template>
  <div>

    <b-container fluid>
      <b-row>
        <b-col>
          <h2 class="pb-3">Instalar Aplicativo</h2>

          <p>Para instalar o aplicativo <u>Easytick</u> no seu celular Android siga os passos:</p>

          <ol>
            <li class="pb-3"><b-link href="https://play.google.com/store/apps/details?id=br.com.easytick.easytick" target="_blank">Acesse a loja de aplicativos do Google</b-link>;</li>
            <li class="pb-3">Clique em Instalar;</li>
          </ol>

          <strong class="ml-4">ou</strong>
          <br>
          <br>

          <ol>
            <li class="pb-3">Abra o aplicativo <u>Câmera</u> do seu celular;</li>
            <li class="pb-3">Leia o QRCode abaixo para acessar a loja de aplicativos do Google;</li>
          </ol>

          <hr>

          QRCode para instalar o aplicativo <u>Easytick</u>.
          <br>
          <canvas ref="canvas"></canvas>
          <br>
          QRCode para instalar o aplicativo <u>Easytick</u>.


        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'OrganizerApp',
  data () {
    return {

    }
  },
  mounted () {
    this.handleQrcode()
  },
  updated () {
    this.handleQrcode()
  },
  methods: {
    handleQrcode () {
      let code = 'https://play.google.com/store/apps/details?id=br.com.easytick.easytick'
      let canvas = this.$refs.canvas
      let opt = { errorCorrectionLevel: 'H', width: 250 }
      QRCode.toCanvas(canvas, code, opt, function (error) {
        if (error) console.error(error)
      })
    }
  }
}
</script>
